import { Box, Chip } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

interface AgentModelInfoProps {
  agentName?: string;
  modelName?: string;
  provider?: string;
}

export default function AgentModelInfo({ agentName, modelName, provider }: AgentModelInfoProps) {
  if (!agentName && !modelName && !provider) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Text variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: 4, opacity: 0.7 }}>
        Agent & Model
      </Text>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {agentName && (
          <Chip
            label={`Agent: ${agentName}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {modelName && (
          <Chip
            label={`Model: ${modelName}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {provider && (
          <Chip
            label={`Provider: ${provider}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
      </Box>
    </Box>
  );
}
